import ApprovalDialog from "@/admin/dashboard/components/approval-dialog/ApprovalDialog";
import ApprovalTypeTag from "@/components/tags/ApprovalTypeTag";
import { Button } from "@/components/ui/button";
import { ApprovalType, LeaveRequestDTO } from "@/models/leave-requests.model";
import { toDateFormatted } from "@/utils/date-format";
import { capitalizeFirstLetter } from "@/utils/string-format";
import { ColumnDef } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";

const ActionCell = ({ row }: { row: any }) => {
  return <ApprovalDialog requestObj={row.original} />;
};
export const columns: ColumnDef<LeaveRequestDTO>[] = [
  {
    accessorFn: (row) => row.type,
    header: "Leave",
    cell: ({ row }) => {
      return <span>{capitalizeFirstLetter(row.original.type)}</span>;
    },
  },
  {
    id: "startDate",
    cell: ({ row }) => {
      return (
        <span>
          {toDateFormatted(row.original.fromDate)}{" "}
          {row.original.fromDateIsAm ? "AM" : "PM"}
        </span>
      );
    },
    accessorFn: (row) => row.fromDate,
    header: ({ column }) => {
      return (
        <div className="flex items-center gap-2">
          Start Date
          <button
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </button>
        </div>
      );
    },
  },

  {
    accessorFn: (row) => row.days,
    header: "Days",
    cell: ({ row }) => {
      return <span className="w-full">{row.original.days}</span>;
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      return <ApprovalTypeTag status={row.original.status} />;
    },
  },

  {
    id: "action",
    cell: ActionCell,
  },
];
